import React from 'react';

const ExtendedWarranty = () => {
  return (
        <div className="tpi-coming-soon font-poppins">
            <h1>Coming Soon</h1>
        </div>
  );
};

export default ExtendedWarranty;
